import qs from 'query-string';
import { Path } from 'history';

export const getQueryStringValue = <T extends string | string[] | null>(key: string, location: Path): T => {
    const queryString = location.search;
    const values = qs.parse(queryString);
    return values[key] as T;
};

export const setQueryStringValue = (key: string, value: string | string[] | null, location: Path): Path => {
    const queryString = location.search;
    const values = qs.parse(queryString);
    const newQsValue = qs.stringify({
        ...values,
        [key]: value,
    });
    return { ...location, search: `?${newQsValue}` };
};
